export default [
    {
        path: 'relatorio-exame-cadastrado',
        component: () => import(
            /* webpackChunkName: 'parametrizacao-relatorio-exame-cadastrado' */
            '@/views/parametrizacao/relatorio-exame-cadastrado/Index'
        ),
        redirect: 'relatorio-exame-cadastrado/index',
        children: [
            {
                name: 'parametrizacao-relatorio-exame-cadastrado-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'parametrizacao-relatorio-exame-cadastrado' */
                    '@/views/parametrizacao/relatorio-exame-cadastrado/List.vue'
                ),
            },
        ],
    },
]